import React, { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { formValueSelector } from 'redux-form'
import PaymentOrder_API_v1 from 'api/payment-orders/v1'
import useWriteToClipboard from 'utils/hooks/useWriteToClipboard'
import { ROUTES } from 'constants/routes'
import { Button, Icon, Spinner } from 'gu-ui-kit'
import styles from 'modules/Forms/Billing/Billing-forms.module.scss'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { notificationShow } from 'modules/Notifications/actions'

export const PaymentOrderButton = ({ form }) => {
  const [successfullyCopied, setSuccessfullyCopied] = useState(false)
  const [processing, setProcessing] = useState(false)
  const pathGen = useGeneratePathI18n()
  const selector = formValueSelector(form)
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { formValues, account_id } = useSelector((state) => ({
    formValues: selector(state, 'method', 'payment_profile_id', 'method', 'payment_amount'),
    account_id: state['billing'].networkAccountData?.id,
  }))

  const writeToClipboard = useWriteToClipboard()

  const generateLink = useCallback(
    (e) => {
      e.preventDefault()
      ;(async () => {
        setProcessing(true)

        const { response, error } = await PaymentOrder_API_v1.createPaymentOrder({
          data: {
            account_id: account_id ?? null,
            payment_profile_id: formValues.payment_profile_id,
            payment_method: formValues.method,
            payment_order_amount: +formValues.payment_amount.value,
            currency: formValues.payment_amount.currency,
          },
        })

        setProcessing(false)

        if (!error) {
          writeToClipboard(
            pathGen(global.location.origin + ROUTES.PAYMENT_ORDER, {
              id: response.data.id,
            }),
          )
          setSuccessfullyCopied(true)

          dispatch(
            notificationShow({
              type: 'success',
              message: 'billing::payment_orders.notifications.order_link_copied_successfully',
              delay: 8000,
            }),
          )

          const time = setTimeout(() => {
            setSuccessfullyCopied(false)
            clearTimeout(time)
          }, 8000)
        }
      })()
    },
    [writeToClipboard, setProcessing, formValues, setSuccessfullyCopied, account_id],
  )

  return (
    <Button
      fullWidth
      align={'center'}
      borderColor={successfullyCopied ? 'Interface-GU-Tertiary' : 'none'}
      borderColorHover={successfullyCopied ? 'Interface-GU-Tertiary' : 'none'}
      borderColorActive={successfullyCopied ? 'Interface-GU-Tertiary' : 'none'}
      color={'Label-GU-Primary'}
      className={clsx(styles['billing__button_payment-order'], {
        [styles['billing__button_payment-order_copied']]: successfullyCopied,
      })}
      bgColor={successfullyCopied ? 'Background-Tertiary' : 'none'}
      size="l"
      variant="primary"
      startIcon={
        processing ? (
          <Spinner
            width={24}
            color={'inherit'}
          />
        ) : (
          <Icon
            name="copy-link"
            color={'inherit'}
            size={'m'}
          />
        )
      }
      onClick={generateLink}
    >
      {t('billing::payment_orders.copy_order_link', {
        context: successfullyCopied ? 'success' : '',
      })}
    </Button>
  )
}

PaymentOrderButton.propTypes = {
  form: PropTypes.string.isRequired,
}
